/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */

    /* Module special vocabulary */
    'payment-methods': {
        menu: {
            index: 'Payment methods',
            incoming: 'Incoming',
            outgoing: 'Outgoing',
        },
        incoming: {
            create: 'New incoming payment method',
            edit: 'Edit a payment method',
            table_titles: {
                id: 'ID',
                pay_id: 'PayID',
                country: 'Country',
                method: 'Method name',
                page_template: 'Template',
                instructions: 'Instructions',
                description: 'Description',
                transaction_fee: 'Transaction fee',
                processing_time: 'Processing time',
                is_default: 'Default method?',
                is_public: 'Public method?',
                is_fast: 'Fast method?',
                setting: 'Edit / Delete',
            }
        },
        outgoing: {
            create: 'New outgoing payment method',
            edit: 'Edit a payment method',
            table_titles: {
                id: 'ID',
                country: 'Country',
                type: 'Type',
                instructions: 'Instructions',
                bank_required: 'Should belongs to bank?',
                info_label1: 'Label1',
                info_label2: 'Label2',
                is_default: 'Default method?',
                setting: 'Edit / Delete',
            }
        },
        templates: {
            address: 'Address',
            amount_to_pay: 'Amount to pay',
            account_name_copied: 'Account name copied!',
            amount_copied: 'Amount copied!',
            important_payment_instructions: 'Important payment instructions',
            network: 'Network',
            fantastic: 'Fantastic',
            our_system_gets_updated_as_soon_as_we_receive_the_payment_at_our_end: 'Our system gets updated as soon as we receive the payment at our end.',
            please_pay_the_exact_amount_do_not_round_this_up_down: 'Please pay the exact amount. Do not round this up/down.',
            bank: 'Bank',
            name: 'Name',
            account_name: 'Account name',
            notes: 'Notes',
            remarks: 'Remarks',
            account_number: 'Account Number',
            iban: 'IBAN',
            id: 'ID',
            card_number: 'Card Number',
            leave_blank: 'Leave blank'
        }
    }
}
